import * as React from "react";
import { IconProps } from "./types";

export const Hurricane03Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M21 4H3M20 8L6 8M18 12L9 12M15 16L8 16M17 20H12"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(Hurricane03Icon as React.FunctionComponent).displayName = "Hurricane03Icon";

export default Hurricane03Icon;
